import { useEffect } from 'react';
import { useMenuNotificationStore } from '../stores/useMenuNotificationStore';

/**
 * Menü bildirim rozetlerine erişim hook'u.
 * Tüm ağ/realtime yaşam döngüsü paylaşılan `useMenuNotificationStore` üzerinden
 * yönetilir; bu hook sadece tüketici kaydı (init/release) yapar ve store'dan
 * seçim yapar. Böylece kaç bileşen kullanırsa kullansın tek polling + tek
 * kanal aboneliği çalışır.
 */
export function useMenuNotifications(userId?: number | null) {
  const counts = useMenuNotificationStore((s) => s.counts);
  const markRead = useMenuNotificationStore((s) => s.markRead);

  useEffect(() => {
    // Kimlik doğrulanmamışsa (örn. login sayfasında kısa süreli mount) istek atma;
    // aksi halde 401 interceptor'ı token'ı siler ve login'e yönlendirir.
    if (!userId) return;
    useMenuNotificationStore.getState().init(userId);
    return () => useMenuNotificationStore.getState().release();
  }, [userId]);

  const getCount = (key?: string) => (key ? counts[key] || 0 : 0);

  return { counts, markRead, getCount };
}
